export enum SuccessModalTypeEnum {
    Success,
    Draft,
    ForValidation,
    AdditionalDocuments
}
